import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import { unstable_editorExperimentParam } from '@atlaskit/tmp-editor-statsig/experiments';
import { createRequestGenerator } from './generator';
export function canNudgeFullPageImproveWriting(_x) {
  return _canNudgeFullPageImproveWriting.apply(this, arguments);
}

/**
 * Checks if the improve writing recommendation meet all the nudge criteria.
 */
function _canNudgeFullPageImproveWriting() {
  _canNudgeFullPageImproveWriting = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var proactiveAIApiUrl, product, context, requestGenerator, canNudge, nudgeMetrics, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, responseState, replaceParagraphTransform;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          proactiveAIApiUrl = _ref.proactiveAIApiUrl, product = _ref.product, context = _ref.context;
          requestGenerator = createRequestGenerator({
            endpoint: proactiveAIApiUrl,
            product: product,
            context: context
          });
          canNudge = false;
          nudgeMetrics = {
            finalConfidence: undefined,
            alternativeConfidence: undefined,
            lengthPercentageDifference: undefined,
            inputReadabilityScore: undefined,
            outputReadabilityScore: undefined
          };
          if (requestGenerator) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", {
            canNudge: canNudge,
            nudgeMetrics: nudgeMetrics
          });
        case 6:
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context.prev = 8;
          _iterator = _asyncIterator(requestGenerator);
        case 10:
          _context.next = 12;
          return _iterator.next();
        case 12:
          if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
            _context.next = 26;
            break;
          }
          responseState = _step.value;
          _context.t0 = responseState.state;
          _context.next = _context.t0 === 'cached' ? 17 : _context.t0 === 'parsed' ? 17 : 23;
          break;
        case 17:
          replaceParagraphTransform = responseState.recommendations.find(function (r) {
            return r.transformType === 'REPLACE_PAGE' && r.type === 'IMPROVE_WRITING';
          });
          if (!(!replaceParagraphTransform || !replaceParagraphTransform.details || replaceParagraphTransform.type !== 'IMPROVE_WRITING')) {
            _context.next = 20;
            break;
          }
          return _context.abrupt("break", 23);
        case 20:
          canNudge = checkNudgeCriteria(replaceParagraphTransform.details);
          nudgeMetrics = {
            finalConfidence: replaceParagraphTransform.details.final_confidence,
            alternativeConfidence: replaceParagraphTransform.details.alternative_confidence,
            lengthPercentageDifference: replaceParagraphTransform.details.length_percentage_difference,
            inputReadabilityScore: replaceParagraphTransform.details.input_readability_score,
            outputReadabilityScore: replaceParagraphTransform.details.output_readability_score
          };
          return _context.abrupt("break", 23);
        case 23:
          _iteratorAbruptCompletion = false;
          _context.next = 10;
          break;
        case 26:
          _context.next = 32;
          break;
        case 28:
          _context.prev = 28;
          _context.t1 = _context["catch"](8);
          _didIteratorError = true;
          _iteratorError = _context.t1;
        case 32:
          _context.prev = 32;
          _context.prev = 33;
          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
            _context.next = 37;
            break;
          }
          _context.next = 37;
          return _iterator.return();
        case 37:
          _context.prev = 37;
          if (!_didIteratorError) {
            _context.next = 40;
            break;
          }
          throw _iteratorError;
        case 40:
          return _context.finish(37);
        case 41:
          return _context.finish(32);
        case 42:
          return _context.abrupt("return", {
            canNudge: canNudge,
            nudgeMetrics: nudgeMetrics
          });
        case 43:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[8, 28, 32, 42], [33,, 37, 41]]);
  }));
  return _canNudgeFullPageImproveWriting.apply(this, arguments);
}
var checkNudgeCriteria = function checkNudgeCriteria(details) {
  var minimalFinalScore = unstable_editorExperimentParam('platform_editor_ai_proactive_ai_nudge_parameters', 'min_final_confidence', {
    defaultValue: -Infinity,
    typeGuard: function typeGuard(value) {
      return typeof value === 'number';
    }
  });
  var minLengthPercentageDifference = unstable_editorExperimentParam('platform_editor_ai_proactive_ai_nudge_parameters', 'min_length_percentage_difference', {
    defaultValue: -Infinity,
    typeGuard: function typeGuard(value) {
      return typeof value === 'number';
    }
  });
  var maxLengthPercentageDifference = unstable_editorExperimentParam('platform_editor_ai_proactive_ai_nudge_parameters', 'max_length_percentage_difference', {
    defaultValue: Infinity,
    typeGuard: function typeGuard(value) {
      return typeof value === 'number';
    }
  });
  var minInputReadabilityScore = unstable_editorExperimentParam('platform_editor_ai_proactive_ai_nudge_parameters', 'min_input_readability_score', {
    defaultValue: -Infinity,
    typeGuard: function typeGuard(value) {
      return typeof value === 'number';
    }
  });
  var minOutputReadabilityScore = unstable_editorExperimentParam('platform_editor_ai_proactive_ai_nudge_parameters', 'min_output_readability_score', {
    defaultValue: -Infinity,
    typeGuard: function typeGuard(value) {
      return typeof value === 'number';
    }
  });
  var maxReadabilityScoreDelta = unstable_editorExperimentParam('platform_editor_ai_proactive_ai_nudge_parameters', 'max_readability_score_delta', {
    defaultValue: Infinity,
    typeGuard: function typeGuard(value) {
      return typeof value === 'number';
    }
  });
  var minReadabilityScoreDelta = unstable_editorExperimentParam('platform_editor_ai_proactive_ai_nudge_parameters', 'min_readability_score_delta', {
    defaultValue: -Infinity,
    typeGuard: function typeGuard(value) {
      return typeof value === 'number';
    }
  });
  var minAlternativeConfidence = unstable_editorExperimentParam('platform_editor_ai_proactive_ai_nudge_parameters', 'min_alternative_confidence', {
    defaultValue: -Infinity,
    typeGuard: function typeGuard(value) {
      return typeof value === 'number';
    }
  });

  // Check final confidence score
  var meetsFinalScoreCriteria = details.final_confidence === undefined || details.final_confidence >= minimalFinalScore;

  // Check min length percentage difference
  var meetsMinLengthCriteria = details.length_percentage_difference === undefined || details.length_percentage_difference >= minLengthPercentageDifference;

  // Check max length percentage difference
  var meetsMaxLengthCriteria = details.length_percentage_difference === undefined || details.length_percentage_difference <= maxLengthPercentageDifference;

  // Check input readability score
  var meetsInputReadabilityCriteria = details.input_readability_score === undefined || details.input_readability_score >= minInputReadabilityScore;

  // Check output readability score
  var meetsOutputReadabilityCriteria = details.output_readability_score === undefined || details.output_readability_score >= minOutputReadabilityScore;

  // Check readability score delta
  var meetsReadabilityDeltaCriteria = details.output_readability_score === undefined || details.input_readability_score === undefined || details.output_readability_score - details.input_readability_score <= maxReadabilityScoreDelta;

  // Check minimum readability score improvement
  var meetsMinReadabilityDeltaCriteria = details.output_readability_score === undefined || details.input_readability_score === undefined || details.output_readability_score - details.input_readability_score >= minReadabilityScoreDelta;

  // Check alternative confidence
  var meetsAlternativeConfidenceCriteria = details.alternative_confidence === undefined || details.alternative_confidence >= minAlternativeConfidence;

  // All criteria must pass
  return meetsFinalScoreCriteria && meetsMinLengthCriteria && meetsMaxLengthCriteria && meetsInputReadabilityCriteria && meetsOutputReadabilityCriteria && meetsReadabilityDeltaCriteria && meetsMinReadabilityDeltaCriteria && meetsAlternativeConfidenceCriteria;
};